import React, { useState, useRef } from "react";
import marcoHorizontal from "../assets/marco-horizontal.png";
import marcoVertical from "../assets/marco-vertical.png";

const DiadelPadre = () => {
  const [imageSrc, setImageSrc] = useState(null);
  const [finalImage, setFinalImage] = useState(null);
  const canvasRef = useRef(null);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      setImageSrc(e.target.result);
    };
    reader.readAsDataURL(file);
  };

  const procesarImagen = () => {
    if (!imageSrc) {
      alert("Subí una imagen primero");
      return;
    }

    const img = new Image();
    img.src = imageSrc;

    img.onload = () => {
      const isVertical = img.height > img.width;
      const marco = new Image();
      marco.src = isVertical ? marcoVertical : marcoHorizontal;

      marco.onload = () => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");

        canvas.width = img.width;
        canvas.height = img.height;

        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        ctx.drawImage(marco, 0, 0, canvas.width, canvas.height);

        const final = canvas.toDataURL("image/png");
        setFinalImage(final);
      };
    };
  };

  return (
    <div style={{
      padding: "2rem",
      backgroundColor: "#f8f9fa",
      color: "#0033A0",
      minHeight: "100vh",
      fontFamily: "'Segoe UI', sans-serif",
      textAlign: "center"
    }}>
      <h1 style={{ fontSize: "2rem", marginBottom: "1.5rem" }}>
        ¡Dale marco a tu foto por el Día del Padre!
      </h1>

      <input
        type="file"
        accept="image/*"
        onChange={handleImageUpload}
        style={{
          margin: "1rem 0",
          padding: "0.5rem",
          border: "2px solid #0033A0",
          borderRadius: "6px",
          backgroundColor: "#fff",
          cursor: "pointer",
          fontWeight: "bold",
          color: "#0033A0"
        }}
      />

      <div>
        <button
          onClick={procesarImagen}
          style={{
            marginTop: "1rem",
            padding: "0.6rem 1.2rem",
            backgroundColor: "#D50032",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            fontSize: "1rem",
            fontWeight: "bold",
            cursor: "pointer"
          }}
        >
          Aplicar Marco
        </button>
      </div>

      {finalImage && (
        <div style={{ marginTop: "2rem" }}>
          <img
            src={finalImage}
            alt="Resultado con marco"
            style={{
              maxWidth: "100%",
              borderRadius: "12px",
              boxShadow: "0 0 10px rgba(0,0,0,0.1)"
            }}
          />
          <div>
            <a
              href={finalImage}
              download="foto-con-marco.png"
              style={{
                display: "inline-block",
                marginTop: "1rem",
                padding: "0.6rem 1.2rem",
                backgroundColor: "#0033A0",
                color: "#fff",
                textDecoration: "none",
                borderRadius: "6px",
                fontWeight: "bold"
              }}
            >
              Descargar imagen
            </a>
          </div>
        </div>
      )}

      <canvas ref={canvasRef} style={{ display: "none" }} />
    </div>
  );
};

export default DiadelPadre;
